import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdClose } from 'react-icons/md';



import images from '../../constants/images';
import './Navbar.css';

import { FiFacebook, FiLinkedin, FiInstagram, FiMail, FiGithub } from 'react-icons/fi'
const linkedin = 'https://www.linkedin.com/in/sharad-tembhurne/';
const email = "mailto:%20sharad.tembhurne@nyu.edu";
const github = "https://github.com/sharadTT";
const facebook = "https://www.facebook.com/sharad97";
const instagram = "https://www.instagram.com/chicken._.biryani/";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);


  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.gericht} color='#c5c6c7' alt="App logo" />
      </div>

      
      <ul className='app__navbar-links'>
        <li className='p__opensans'><a href="#home">Home</a></li>
        <li className='p__opensans'><a href="#about">About</a></li>
        <li className='p__opensans'><a href="#projects">Projects</a></li>
        <li className='p__opensans'><a href="#experience">Experience</a></li>
        <li className='p__opensans'><a href="#skills">Skills</a></li>
        <li className='p__opensans'><a href="#contact">Contact</a></li>
      </ul>

      <div className='app__navbar-links_icons'>
      <a href={linkedin} target="_blank" rel="noopener noreferrer">
            <FiLinkedin />
          </a>
          <a href={email} target="_blank" rel="noopener noreferrer">
            <FiMail />
          </a>
          <a href={github} target="_blank" rel="noopener noreferrer">
            <FiGithub />
          </a>
          <a href={facebook} target="_blank" rel="noopener noreferrer">
            <FiFacebook />
          </a>
          <a href={instagram} target="_blank" rel="noopener noreferrer">
            <FiInstagram />
          </a>
      </div>

      <div className='app__navbar-smallscreen'>
        <GiHamburgerMenu color="#66fcf1" fontSize={27} onClick={() => setToggleMenu(true)} />

        {toggleMenu && (

          <div className='app__navbar-smallscreen_overlay flex__center slide-bottom'>
            <MdClose fontSize={27} className="overlay__close" onClick={() => setToggleMenu(false)} />
            <ul className='app__navbar-smallscreen_links' onClick={() => setToggleMenu(false)}>
              <li className='p__opensans'><a href="#home">Home</a></li>
              <li className='p__opensans'><a href="#about">About</a></li>
              <li className='p__opensans'><a href="#experience">Experience</a></li>
              <li className='p__opensans'><a href="#projects">Projects</a></li>
              <li className='p__opensans'><a href="#skills">Skills</a></li>
              <li className='p__opensans'><a href="#contact">Contact</a></li>
            </ul>

            <div className='app__navbar-smallscreenlinks_icons'>
      <a href={linkedin} target="_blank" rel="noopener noreferrer">
            <FiLinkedin />
          </a>
          <a href={email} target="_blank" rel="noopener noreferrer">
            <FiMail />
          </a>
          <a href={github} target="_blank" rel="noopener noreferrer">
            <FiGithub />
          </a>
          <a href={facebook} target="_blank" rel="noopener noreferrer">
            <FiFacebook />
          </a>
          <a href={instagram} target="_blank" rel="noopener noreferrer">
            <FiInstagram />
          </a>
      </div>
          </div>
        )}

      </div>
    </nav>
  )
}

export default Navbar;
